/*eslint-disable*/
const useEnv = JSON.parse(process.env.VUE_APP_USE_ENV);
const api = useEnv ? '${VUE_APP_APIPATH}' : (process.env.VUE_APP_APIPATH || '');
const combase=useEnv?'${VUE_APP_COMBASE_URL}': process.env.VUE_APP_COMBASE_URL;
const mbcbase=useEnv?'${VUE_APP_MBCBASE_URL}': process.env.VUE_APP_MBCBASE_URL;
const nanshandomain=useEnv?'${VUE_APP_NANSHAN_DOMAN}': process.env.VUE_APP_NANSHAN_DOMAN;
const rmubase=useEnv?'${VUE_APP_RMUBASE_URL}': process.env.VUE_APP_RMUBASE_URL;
const ssobase=useEnv?'${VUE_APP_SSOBASE_URL}': process.env.VUE_APP_SSOBASE_URL;
const tecommon=useEnv?'${VUE_APP_API_TECOMMON}': process.env.VUE_APP_API_TECOMMON;
const baseurl=useEnv?'${VUE_APP_BASE_URL}': process.env.VUE_APP_BASE_URL;
const fbappid=useEnv?'${VUE_APP_FB_APPID}': process.env.VUE_APP_FB_APPID;
const title=useEnv?'${VUE_APP_TITLE}': process.env.VUE_APP_TITLE;
const googleclientid=useEnv?'${VUE_APP_GOOGLE_CLIENTID}': process.env.VUE_APP_GOOGLE_CLIENTID;
const linelogindomain=useEnv?'${VUE_APP_LINE_LOGIN_DOMAN}': process.env.VUE_APP_LINE_LOGIN_DOMAN;
const companyid=useEnv?'${VUE_APP_COMPANYID}': process.env.VUE_APP_COMPANYID;
const nodeenv=useEnv?'${NODE_ENV}': process.env.NODE_ENV;
const lineclientid=useEnv?'${VUE_APP_LINE_CLIENTID}': process.env.VUE_APP_LINE_CLIENTID;


export {
  api,
  combase,
  mbcbase,
  nanshandomain,
  rmubase,
  ssobase,
  tecommon,
  baseurl,
  fbappid,
  title,
  googleclientid,
  linelogindomain,
  companyid,
  nodeenv,
  lineclientid
};
